import routesRefinanciamento from '@routes/routes'

export const rootBackPaths: string[] = [
  routesRefinanciamento.CONTRATOS_V1,
  routesRefinanciamento.CONTRATOS,
  routesRefinanciamento.ROOT,
  routesRefinanciamento.SEM_EMPRESTIMO_V1,
  routesRefinanciamento.SEM_EMPRESTIMO,
  routesRefinanciamento.SEM_PARCELA,
  routesRefinanciamento.DESQUALIFICACAO,
]
